import React from 'react';
import { MapPin } from '@phosphor-icons/react';
import { Spot } from 'utils/constants';
import { LatLng, formatDistanceAway, formatSpotAddress, getRateOptions, pickRateOption } from 'utils/spotSearch';
import styles from './FindParking.module.css';

type SpotPopupProps = {
    spot: Spot;
    rentalType: string;
    origin?: LatLng;
};

const SpotPopup: React.FC<SpotPopupProps> = ({ spot, rentalType, origin }) => {
    const options = getRateOptions(spot);
    const booking = pickRateOption(options, rentalType);
    const distance = formatDistanceAway(origin, spot);

    return (
        <div className={styles.popup} role="dialog" aria-label={spot.name}>
            <div>
                <div className={styles.popupName}>{spot.name}</div>
                <div className={styles.popupAddress}>{formatSpotAddress(spot)}</div>
                {distance && (
                    <div className={styles.popupMeta}>
                        <MapPin size={12} />
                        {distance}
                    </div>
                )}
            </div>
            {options.length > 0 && (
                <div className={styles.popupRates}>
                    {options.map((option) => (
                        <div key={option.key} className={styles.popupRate}>
                            <span className={styles.popupRateLabel}>{option.label}</span>
                            <span className={styles.popupRatePrice}>
                                {option.rangeLabel || option.price}{' '}
                                {!option.moving && <span className={styles.popupRateUnit}>{option.unit}</span>}
                            </span>
                        </div>
                    ))}
                </div>
            )}
            {booking && (
                <a className={styles.popupButton} href={booking.bookingUrl} target="_blank" rel="noopener noreferrer">
                    Book Now
                </a>
            )}
            <div className={styles.popupArrow} aria-hidden="true" />
        </div>
    );
};

export default SpotPopup;
